import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { captureUtms } from "@/lib/utm";

/**
 * Invisible auto-tagger — mounts at App root, captures UTMs from URL into
 * sessionStorage on first load and on any route change. No UI rendered.
 */
export default function UtmAutoTag() {
  const location = useLocation();
  useEffect(() => {
    captureUtms();
  }, [location.pathname, location.search]);
  return null;
}
